import moment from "moment/moment";

const getMomentWithLocale = (date: string, locale?: string) => {
    const safeLocale = locale === 'ru' ? 'ru' : 'en';
    moment.locale(safeLocale);
    return moment.utc(date);
};

export const formatDateToApi = (date: string): string => {
    return moment.utc(date).format('DD.MM.YYYY');
}

export const formatDate = (date: string, locale?: string, format: 'day' | 'full' | 'datetime' | 'time' = 'day'): string => {
    const m = getMomentWithLocale(date, locale);

    switch (format) {
        case 'time':
            return m.format('HH:mm');
        case 'full':
            return m.format(locale === 'ru' ? 'D MMMM YYYY' : 'MMMM D, YYYY');
        case 'datetime':
            return m.format(locale === 'ru' ? 'D MMMM YYYY HH:mm' : 'MMMM D, YYYY HH:mm');
        case 'day':
        default:
            return m.format(locale === 'ru' ? 'D MMMM' : 'MMMM D');
    }
}
import moment from "moment/moment";

const getMomentWithLocale = (date: string, locale?: string) => {
    const safeLocale = locale === 'ru' ? 'ru' : 'en';
    moment.locale(safeLocale);
    return moment.utc(date);
};

export const formatDateToApi = (date: string): string => {
    return moment.utc(date).format('DD.MM.YYYY');
}

export const formatDate = (date: string, locale?: string, format: 'day' | 'full' | 'datetime' | 'time' = 'day'): string => {
    const m = getMomentWithLocale(date, locale);

    switch (format) {
        case 'time':
            return m.format('HH:mm');
        case 'full':
            return m.format(locale === 'ru' ? 'D MMMM YYYY' : 'MMMM D, YYYY');
        case 'datetime':
            return m.format(locale === 'ru' ? 'D MMMM YYYY HH:mm' : 'MMMM D, YYYY HH:mm');
        case 'day':
        default:
            return m.format(locale === 'ru' ? 'D MMMM' : 'MMMM D');
    }
}
